<template>
  <el-row>
    <el-row class="movie-list">
      <el-col :md="16" style="padding-right: 5px; padding-left: 5px; padding-bottom: 5px">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>文件存储配置</span>
            <el-button style="float: right; padding: 3px 0" type="text" @click="onAdd">添加</el-button>
          </div>
          <div class="text item">
            <el-table
              :data="storeConfigList"
              border
              style="width: 100%"
            >
              <el-table-column
                prop="ossType"
                label="存储类型"
              />
              <el-table-column
                prop="endpoint"
                label="Endpoint"
              />
              <el-table-column
                prop="accessKeyId"
                label="AccessKeyId"
              />
              <el-table-column
                prop="accessKeySecret"
                label="AccessKeyIdSecret"
              />
              <el-table-column
                fixed="right"
                label="操作"
              >
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="danger"
                    @click="onApprove(scope.row)"
                  >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-dialog
      append-to-body
      :visible.sync="addDialog"
      width="30%"
      center
    >
      <el-row style="padding-right: 5px; padding-left: 5px; padding-bottom: 5px; text-align: center">
        <el-form ref="form" :model="addForm" label-width="120px">
          <el-form-item label="OSS 类型">
            <el-select v-model="addForm.ossType" placeholder="" style="padding-right: 1px">
              <el-option label="本地 OSS" value="1" />
              <el-option label="阿里云 OSS" value="2" />
            </el-select>
          </el-form-item>
          <el-form-item label="Endpoint">
            <el-input
              v-model="addForm.endpoint"
              type="password"
              placeholder=""
              style="padding-right: 1px"
              clearable
            />
          </el-form-item>
          <el-form-item label="AccessKeyId">
            <el-input
              v-model="addForm.accessKeyId"
              type="password"
              placeholder=""
              style="padding-right: 1px"
              clearable
            />
          </el-form-item>
          <el-form-item label="AccessKeySecret">
            <el-input
              v-model="addForm.accessKeySecret"
              type="password"
              placeholder=""
              style="padding-right: 1px"
              clearable
            />
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click.native="onAddSubmit"
            >添加</el-button>
            <el-button
              type="primary"
              @click.native="addDialog = false"
            >取消</el-button>
          </el-form-item>
        </el-form>
      </el-row>
    </el-dialog>
  </el-row>
</template>

<script>
import { userMixin } from 'assets/js/mixin'
import {
  addFileStoreConfig,
  getFileStoreConfig
} from '@/api/admin'

export default {
  name: 'AdminStoreConfig',
  mixins: [userMixin],
  data() {
    return {
      storeConfigList: null,
      addDialog: false,
      addForm: {
        ossType: '1',
        endpoint: null,
        accessKeyId: null,
        accessKeySecret: null
      }
    }
  },
  created() {
    this.getData()
  },
  mounted() {
  },
  methods: {
    getData() {
      getFileStoreConfig().then(resp => {
        if (resp.code === 0) {
          this.storeConfigList = resp.data
        }
      })
    },
    // ****************************************************************************************************************
    onAdd() {
      this.addDialog = true
    },
    onAddSubmit() {
      this.addDialog = false
      addFileStoreConfig(this.addForm).then(resp => {
        this.$message.info(resp.msg)
      }).catch(error => {
        this.$message.error(error.message)
      })
    },
    onApprove(row) {
      this.$message.info('id -> ' + row.id)
    }
  }
}
</script>

<style>
</style>
